import React from 'react';

const swapPhotoCache = new Map();

export function SwapCandidateThumb({ name, city }) {
  const query = `${name} ${city || ''}`.trim();
  const [url, setUrl] = React.useState(swapPhotoCache.get(query) || null);
  React.useEffect(() => {
    if (swapPhotoCache.has(query)) { setUrl(swapPhotoCache.get(query)); return; }
    let cancelled = false;
    // city must be sent as its own param, not just folded into `query` — the
    // backend (api/photo.js fetchSinglePhoto) strips a trailing city token off
    // the query using this exact param to get a clean name for DB matching.
    // Without it, DB lookups for real attractions with their own stored photo
    // silently miss and fall back to generic Unsplash/Pexels keyword search,
    // which can return the same generic stock photo for unrelated names.
    fetch(`/api/photo?query=${encodeURIComponent(query)}&city=${encodeURIComponent(city || '')}`)
      .then(r => r.json())
      .then(d => {
        const u = d?.url || '';
        swapPhotoCache.set(query, u);
        if (!cancelled) setUrl(u);
      })
      .catch(() => { swapPhotoCache.set(query, ''); });
    return () => { cancelled = true; };
  }, [query, city]);
  return url
    ? <img src={url} alt={name} loading="lazy" style={{ width:'100%', height:'100%', objectFit:'cover' }} onError={e=>{e.target.style.display='none';}}/>
    : <div style={{ width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'center', color:'#cbd5e1', fontSize:18 }}>📍</div>;
}
